import { usdtToken } from '@shared/data/token'
import {
  CHAIN_ID,
  ETH_DENOMS,
  ARBITRUM_DENOMS,
  INJECTIVE_DENOMS
} from '../constants/asset-priority-map'
import type { Asset } from '@skip-go/client'

const injLogoUrl =
  'https://imagedelivery.net/lPzngbR8EltRfBOi_WYaXw/efaa2c96-5463-4707-0d2b-19e5b63df000/public'

export const TOKEN_REMAP: Record<string, Record<string, Partial<Asset>>> = {
  [CHAIN_ID.Ethereum]: {
    [ETH_DENOMS.INJECTIVE]: {
      logoUri: injLogoUrl,
      coingeckoId: 'injective-protocol'
    },

    [ETH_DENOMS.ETHEREUM_NATIVE]: {
      logoUri:
        'https://raw.githubusercontent.com/axelarnetwork/axelar-configs/main/images/tokens/weth.svg'
    }
  },

  [CHAIN_ID.Injective]: {
    inj: {
      logoUri: injLogoUrl
    },
    [INJECTIVE_DENOMS.USDT_PEGGY]: {
      symbol: 'USDT',
      recommendedSymbol: 'USDT',
      logoUri: usdtToken.logo || usdtToken.externalLogo || ''
    },
    [INJECTIVE_DENOMS.WETH_PEGGY]: {
      symbol: 'WETH',
      recommendedSymbol: 'WETH',
      logoUri:
        'https://raw.githubusercontent.com/axelarnetwork/axelar-configs/main/images/tokens/weth.svg'
    },
    [INJECTIVE_DENOMS.OMNI_PEGGY]: {
      decimals: 18
    },
    [INJECTIVE_DENOMS.APP_PEGGY]: {
      recommendedSymbol: 'APP'
    }
  },

  [CHAIN_ID.Arbitrum]: {
    [ARBITRUM_DENOMS.WETH]: {
      logoUri:
        'https://raw.githubusercontent.com/axelarnetwork/axelar-configs/main/images/tokens/weth.svg'
    },
    [ARBITRUM_DENOMS.INJ]: {
      logoUri: injLogoUrl
    }
  }
}
